/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import doneBoxStyle from "./doneBoxStyle";
import Grid from "@mui/material/Grid";
import ContentBoxHead from "../../../Box/ContentBox/ContentBoxHead";
import IconData from "../../../../assets/icons/generic/toggleable/IconData";
import Typography from "@mui/material/Typography";
import CaseDetailsItem from "../../../Serviceworld/Common/CaseDetailsItem/CaseDetailsItem";
import ChildrenSection from "./ChildrenSection";
import PersonSection from "./PersonSection";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";
import { Divider } from "@mui/material";

type SummaryBoxProps = {
  product: AbstractCase;
};

export default function SummaryBox({ product }: SummaryBoxProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Paper sx={doneBoxStyle.box} elevation={4}>
      <Grid container sx={doneBoxStyle.headlineContainer}>
        <Grid item>
          <ContentBoxHead headline={"Meine Angaben"} Icon={IconData} />
        </Grid>
      </Grid>
      <Typography variant={"h6"} sx={doneBoxStyle.subheader}>
        Ehe und Scheidung
      </Typography>
      <Divider sx={doneBoxStyle.divider} />
      <Grid container>
        <CaseDetailsItem caseData={product} fieldPath={"dateMarriage"} fieldType={"date"} />
        <CaseDetailsItem caseData={product} fieldPath={"cityMarriage"} />
        <CaseDetailsItem caseData={product} fieldPath={"numberChildren"} />
        <CaseDetailsItem caseData={product} fieldPath={"statusDivorce"} />
        <CaseDetailsItem caseData={product} fieldPath={"dateSeparation"} fieldType={"date"} />
        <CaseDetailsItem caseData={product} fieldPath={"movedOut"} />
        {product.movedOut !== "nobody" && <CaseDetailsItem caseData={product} fieldPath={"dateMovedOut"} fieldType={"date"} />}
      </Grid>

      {isExpanded && (
        <div>
          <PersonSection product={product} personType={"partner"} />
          <PersonSection product={product} personType={"client"} />
          <Typography variant={"h6"} sx={doneBoxStyle.subheader}>
            Letzte gemeinsame Adresse
          </Typography>
          <Divider sx={doneBoxStyle.divider} />
          <CaseDetailsItem caseData={product} fieldPath={"commonAddress.streetAddress"} />
          <CaseDetailsItem caseData={product} fieldPath={"commonAddress.postalCode"} />
          <CaseDetailsItem caseData={product} fieldPath={"commonAddress.addressLocality"} />
          <Typography variant={"h6"} sx={doneBoxStyle.subheader}>
            Kontaktdaten
          </Typography>
          <Divider sx={doneBoxStyle.divider} />
          <CaseDetailsItem caseData={product} fieldPath={"customer.email"} />
          <CaseDetailsItem caseData={product} fieldPath={"customer.telephone"} />
          <CaseDetailsItem caseData={product} fieldPath={"customer.contactTime"} />
          <Typography variant={"h6"} sx={doneBoxStyle.subheader}>
            Finanzen
          </Typography>
          <Divider sx={doneBoxStyle.divider} />
          <CaseDetailsItem caseData={product} fieldPath={"netIncomePetitioner"} />
          <CaseDetailsItem caseData={product} fieldPath={"netIncomePartner"} />
          {!product.shortMarriage && <CaseDetailsItem caseData={product} fieldPath={"pensionsExcluded"} />}
          {product.pensionsExcluded === false && (
            <>
              <CaseDetailsItem caseData={product} fieldPath={"numberPensions"} />
              <CaseDetailsItem caseData={product} fieldPath={"numberPensionsPartner"} />
              <CaseDetailsItem caseData={product} fieldPath={"pensionsQuestions"} />
            </>
          )}
          <CaseDetailsItem caseData={product} fieldPath={"hasProcessCostSupport"} />
          <ChildrenSection divorce={product} />
        </div>
      )}
      <Button fullWidth color={"primary"} onClick={() => setIsExpanded(!isExpanded)}>
        {isExpanded ? "Weniger anzeigen" : "Alle anzeigen"}
      </Button>
    </Paper>
  );
}
